import { render, staticRenderFns } from "./no-content.vue?vue&type=template&id=4b2608a6&scoped=true&"
import script from "./no-content.vue?vue&type=script&lang=js&"
export * from "./no-content.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b2608a6",
  null
  
)

export default component.exports